var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loaded)?_c('loader',{attrs:{"size":24}}):_c('img',_vm._b({ref:"baseImage",attrs:{"src":_vm.content,"alt":_vm.alt},on:{"load":function($event){_vm.loaded = true},"click":function($event){return _vm.$emit('click')}}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }